<template>
        <crud-update :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @update="update"
                 @close="$emit('close')"
    >
         <reporte-stock-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-update>
</template>

<script>

    import ReporteStockProvider from "../../../../providers/ReporteStockProvider";
    
    import {CrudUpdate, ClientError} from '@dracul/common-frontend'
    
    import ReporteStockForm from "../ReporteStockForm";
  
    

    export default {
        name: "ReporteStockUpdate",
        
        components: { ReporteStockForm, CrudUpdate },
        
        props:{
          open: {type: Boolean, default: true},
          item: {type: Object, required: true}
        },

        data() {
            return {
                title: 'cobrox.reporteStock.editing',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                id: this.item.id,
                form: {
                    creadoPor: this.item.creadoPor ? this.item.creadoPor.id : null,
                    url: this.item.url,
                    data: this.item.data
                }
            }
        },
        methods: {
            update() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    ReporteStockProvider.updateReporteStock(this.id, this.form).then(r => {
                            if (r) {
                                this.$emit('itemUpdated',r.data.updateReporteStock)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }
        },
    }
</script>

<style scoped>

</style>

